module.exports = __webpack_public_path__ + "img/award-bg-in.9686efe8.png";